module.exports = __webpack_public_path__ + "static/media/fight-solo.95b91c04.png";